class SubmenuNavigation {
    constructor(root = document) {
        this.root = root;
        this.buttons = Array.from(root.querySelectorAll('.submenu-toggle'));
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    }

    init() {
        if (!this.buttons.length) {
            return;
        }

        this.buttons.forEach((button) => {
            const item = button.parentElement;
            const submenu = document.getElementById(button.getAttribute('aria-controls'));

            if (!item || !submenu) {
                return;
            }

            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
            });

            button.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    this.setExpanded(button, true);
                    const firstLink = submenu.querySelector('a, button');
                    if (firstLink) {
                        firstLink.focus();
                    }
                }

                if (event.key === 'Escape') {
                    event.preventDefault();
                    this.setExpanded(button, false, false);
                    button.focus();
                }
            });

            submenu.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    this.setExpanded(button, false, false);
                    button.focus();
                }
            });

            item.addEventListener('mouseenter', () => {
                if (this.canHover.matches) {
                    this.setExpanded(button, true);
                }
            });

            item.addEventListener('mouseleave', () => {
                if (this.canHover.matches && !item.contains(document.activeElement)) {
                    this.setExpanded(button, false, false);
                }
            });
        });

        document.addEventListener('click', (event) => {
            if (!event.target.closest('.menu-item-has-children')) {
                this.closeAll();
            }
        });

        document.addEventListener('focusin', (event) => {
            this.buttons.forEach((button) => {
                const item = button.parentElement;
                if (button.getAttribute('aria-expanded') === 'true' && !item.contains(event.target)) {
                    this.setExpanded(button, false, false);
                }
            });
        });
    }

    setExpanded(button, expanded, closeOthers = true) {
        const item = button.parentElement;
        const submenu = document.getElementById(button.getAttribute('aria-controls'));

        if (!item || !submenu) {
            return;
        }

        if (expanded && closeOthers) {
            this.closeAll(button);
        }

        button.setAttribute('aria-expanded', String(expanded));
        item.classList.toggle('is-submenu-open', expanded);
        submenu.hidden = !expanded;
    }

    closeAll(exceptButton = null) {
        this.buttons.forEach((button) => {
            if (button !== exceptButton && button.getAttribute('aria-expanded') === 'true') {
                this.setExpanded(button, false, false);
            }
        });
    }
}

export default SubmenuNavigation;
